const getTierForQuantity = (tierObject, quantity) => {
  for (let i = 1, len = tierObject.length; i < len; i++) {
    if (quantity < tierObject[i]['quantity']) return tierObject[i - 1];
    else if (quantity === tierObject[i]['quantity']) return tierObject[i];
  }
  if (tierObject?.length > 0) return tierObject[tierObject.length - 1];
};

export default {
  getTierForQuantity
}